/*
Copyright 2026 Dexnet / iON.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/*
 * iON (BUGS 184 / 209, design-tasks/avatar-colors.md): an avatar without a
 * photo has the same colour as in the apps — one of 8 gradients picked by
 * the sum of the UTF-16 codes of the id, mod 8, with white initials.
 * The id of a person is their @user_id (also for a chat of two), of a group
 * its !room_id.
 */

import { type CSSProperties } from "react";

const TONES: [string, string][] = [
  ["#5AA6FF", "#2A62F0"], // Blue
  ["#3FCBE3", "#1290B3"], // Aqua
  ["#4FD39C", "#178F67"], // Green
  ["#A08AFF", "#5F3FD9"], // Violet
  ["#FF85B8", "#D23A82"], // Pink
  ["#FFB060", "#E06A1F"], // Orange
  ["#FF8577", "#D13C34"], // Coral
  ["#7C879A", "#3A4252"], // Graphite
];

export function ionAvatarIndex(id: string): number {
  let sum = 0;
  for (let i = 0; i < id.length; i++) sum += id.charCodeAt(i);
  return sum % TONES.length;
}

/** Style for Element Call's Avatar: the iON colour of `id`. */
export function ionAvatarStyle(id: string): CSSProperties {
  const [from, to] = TONES[ionAvatarIndex(id)];
  return {
    "--cpd-avatar-bg": `linear-gradient(135deg, ${from} 14%, ${to} 86%)`,
    "--cpd-avatar-color": "#FFFFFF",
    // Compound also draws a border in the background colour
    borderColor: "transparent",
  } as CSSProperties;
}
